import React, { useState } from 'react'

interface IProps {
    onChange: (groupId: string) => void;
    label: string;
}

export const AdminVerifiedFilter = ({ onChange, label }: IProps) => {
    const list = [
        { id: 'all', name: 'All' }, 
        { id: 'null', name: 'Pending' },
        { id: 'true', name: 'Verified' },
        { id: 'false', name: 'Rejected' }
    ];
    const [itemSelected, setItemSelected] = useState<any>('');
  
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value;
        onChange(value);
        setItemSelected(value);
    }
  
    return (
      <div>
        <div>
          <span className="text-muted">{label}:</span>
        </div>
        <select 
            className={`form-control`}
            name="occupations"
            style={{ width: '220px' }}
            onChange={handleChange}
            value={itemSelected || ''}
        >
            {
                list.map((item, index) => (
                    <option key={index} value={item.id}>{item.name}</option>
                ))
            }
        </select>
      </div>
    );
  }
